export default "__VITE_ASSET__o1vFVSBV__"